export default {
    school(state) {
        return state.school;
    },
    getSchools(state) {
        return state.schools;
    },
    getCurrentSchoolId(state) {
        return state.currentSchoolId;
    },
    getTeachers(state) {
        return state.school?.teachers;
    },
    getSchoolId(state) {
        return state.currentSchoolId || state.school?._id;
    },
    getAttendanceTeachers(state) {
        return state.attendanceTeachers;
    }
}